module.exports = __webpack_public_path__ + "plane-blueprint-deep.e47529caf219a65018c9.svg";


//////////////////
// WEBPACK FOOTER
// /vercel/workpath0/src/assets/img/plane-blueprint-deep.svg
// module id = ../../../../../src/assets/img/plane-blueprint-deep.svg
// module chunks = main